import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const itemsPerView = 3;
  const maxIndex = Math.max(0, testimonials.length - itemsPerView);

  const prev = () => setCurrent(Math.max(0, current - 1));
  const next = () => setCurrent(Math.min(maxIndex, current + 1));

  const visible = testimonials.slice(current, current + itemsPerView);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-4">
            用户评价
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            来自创作者的真实反馈
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            超过10万用户的共同选择，听听他们怎么说。
          </p>
        </div>

        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {visible.map((t) => (
              <div
                key={t.id}
                className="p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200/70"
              >
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <div
                      key={i}
                      className="w-4 h-4 flex items-center justify-center"
                    >
                      <i
                        className={`ri-star-fill text-sm ${
                          i < t.rating
                            ? "text-accent-500"
                            : "text-secondary-200"
                        }`}
                      ></i>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-6">
                  {t.content}
                </p>
                <div className="flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-medium text-foreground-950">
                      {t.name}
                    </p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-center gap-3 mt-8">
            <button
              onClick={prev}
              disabled={current === 0}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:text-foreground-950 hover:border-foreground-400 transition-colors duration-200 disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={next}
              disabled={current >= maxIndex}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:text-foreground-950 hover:border-foreground-400 transition-colors duration-200 disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}